import { ObjectMapper } from 'json-object-mapper';
import { Model, OptionModel } from '../model';
import { IModel } from '../IModel';
import { CompetenceMatrixModel } from './competenceMatrix.model';
import { JobTitleFamilyTypeEnum } from 'services/enums/JobTitleFamilyType.enum';

export class JobTitleFamilyModel extends Model implements IModel<JobTitleFamilyModel> {
  companyGroupId: string | undefined = undefined;
  name: string = '';
  description: string = '';
  foreignId: string | undefined = undefined;
  type: any = JobTitleFamilyTypeEnum.None.value;

  competenceMatrices?: CompetenceMatrixModel[] = [];

  static create(input: any): JobTitleFamilyModel {
    const model = ObjectMapper.deserialize<JobTitleFamilyModel>(JobTitleFamilyModel, input);
    return model;
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }

  toOption(): OptionModel {
    return { label: `${this.name}`, value: this.id } as OptionModel;
  }
}